import History from "../../script/History";

import ArticoliIcon from '@iconify/icons-fluent/food-toast-24-regular';
import FilterAddIcon from '@iconify/icons-fluent/filter-add-20-regular';
import FornitoriAnagrafica from '@iconify/icons-fluent/document-table-truck-24-regular';
import PrintIcon from "@mui/icons-material/Print";
import PiattiIcon from '@iconify/icons-fluent/food-24-regular';
import RequestQuoteIcon from '@mui/icons-material/Receipt';
import TimeLineIcon from '@mui/icons-material/Timeline';
import IncassiIcon from '@iconify/icons-fluent/book-pulse-24-regular';
import MagaizzinoIcon from '@iconify/icons-fluent/box-24-regular';
import StaffIcon from '@iconify/icons-fluent/people-48-regular';
import ArrowTranding from '@iconify/icons-fluent/receipt-money-24-regular';
import StaffMoneyIcon from '@iconify/icons-fluent/people-money-24-regular';
import TempisticheIcon from '@iconify/icons-fluent/timer-24-regular';
import FornitoriIcon from '@iconify/icons-fluent/vehicle-truck-cube-24-regular';
import { Icon } from "@iconify/react";
import UserAuthenticated from "../../auth/UserAuthenticated";
import { NavigateFunction } from "react-router-dom-v5-compat";

export function createBiItemList(ristoranteId: string, navigate: NavigateFunction) {
    return [
        {
            title: "Business Intelligence",
            items: [
                {
                    icon: <Icon icon={ArrowTranding} width={25} />,
                    text: "Profit & Loss",
                    onClick: () => navigate(`/bi/${ristoranteId}/pl`),
                },
                {
                    icon: <Icon icon={IncassiIcon} width={25} />,
                    text: "Area incassi",
                    onClick: () => navigate(`/bi/${ristoranteId}/incassi`),

                },
                {
                    icon: <Icon icon={TempisticheIcon} width={25} />,
                    text: "Area tempistiche",
                    onClick: () => navigate(`/bi/${ristoranteId}/tempistiche`),
                },
                {
                    icon: <Icon icon={PiattiIcon} width={25} />,
                    text: "Analisi piatti",
                    onClick: () => navigate(`/bi/${ristoranteId}/piatti`),
                },
                {
                    icon: <Icon icon={StaffMoneyIcon} width={25} />,
                    text: "Staff",
                    onClick: () => navigate(`/bi/${ristoranteId}/staff`),
                },
            ]
        }
    ];
}

export function createAdministrationItemList(ristoranteId: string, navigate: NavigateFunction) {
    return [
        {
            title: "Anagrafica",
            items: [
                {
                    icon: <Icon icon={ArticoliIcon} width={25} />,
                    text: "Articoli",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/anagraficaArticoli`),
                    url: `/myAccount/${ristoranteId}/anagraficaArticoli`
                },
            ]
        },
        {
            title: "Modulo magazzino",
            items: [
                {
                    icon: <Icon icon={MagaizzinoIcon} width={25} />,
                    text: "Giacenza",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/giacenza`),
                    url: `/myAccount/${ristoranteId}/giacenza`
                },
                {
                    icon: <Icon icon={MagaizzinoIcon} width={25} />,
                    text: "Scarti",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/scarti`),
                    url: `/myAccount/${ristoranteId}/scarti`
                }
            ]
        },
        {
            title: "Modulo fatture",
            items: [
                {
                    icon: <Icon icon={FornitoriIcon} width={25} />,
                    text: "Fatture",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/fatture`),
                    url: `/myAccount/${ristoranteId}/fatture`
                },
                {
                    icon: <Icon icon={FornitoriAnagrafica} width={25} />,
                    text: "Fornitore",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/anagraficaFornitori`),
                    url: `/myAccount/${ristoranteId}/anagraficaFornitori`
                },
                {
                    icon: <Icon icon="fluent:reciept-24-filled" width={25} />,
                    text: "Ricevute",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/ricevute`),
                    url: `/myAccount/${ristoranteId}/ricevute`
                }
            ]
        },
        {
            title: "Modulo staff",
            items: [
                {
                    icon: <Icon icon={StaffIcon} width={25} />,
                    text: "Calendario",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/calendario`),
                    url: `/myAccount/${ristoranteId}/calendario`
                },
                {
                    icon: <Icon icon={StaffIcon} width={25} />,
                    text: "Ruoli",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/ruoli`),
                    url: `/myAccount/${ristoranteId}/ruoli`
                },
                {
                    icon: <Icon icon={StaffIcon} width={25} />,
                    text: "Collaboratori",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/collaboratori`),
                    url: `/myAccount/${ristoranteId}/collaboratori`
                }
            ]
        },
        {
            title: "Menu",
            items: [
                {
                    icon: <Icon icon={"fluent:book-24-regular"} width={25} />,
                    text: "Menu",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/menu`),
                    url: `/myAccount/${ristoranteId}/menu`
                },
                {
                    icon: <Icon icon={FilterAddIcon} width={25} />,
                    text: "Sezioni aggiuntive",
                    onClick: () => navigate(`/myAccount/${ristoranteId}/sezioniAggiuntive`),
                    url: `/myAccount/${ristoranteId}/sezioniAggiuntive`
                }
            ]
        }
    ]
}


export function createOpsItemList(ristoranteId: string, navigate: NavigateFunction) {
    return [
        {
            title: "Cassa",
            items: [
                {
                    icon: <Icon icon={PiattiIcon} width={25} />,
                    text: "Tavoli",
                    onClick: () => navigate(`/cassa/${ristoranteId}/tavoli`),
                    url: `/cassa/${ristoranteId}/tavoli`

                },
                {
                    icon: <RequestQuoteIcon />,
                    text: "Pagamenti",
                    onClick: () => navigate(`/cassa/${ristoranteId}/pagamenti`),
                    url: `/cassa/${ristoranteId}/pagamenti`
                },
                {
                    icon: <TimeLineIcon />,
                    text: "Resoconto",
                    onClick: () => navigate(`/cassa/${ristoranteId}/resoconto`),
                    url: `/cassa/${ristoranteId}/resoconto`
                },
                {
                    icon: <Icon icon="fluent:calendar-24-regular" width="24" height="24" />,
                    text: "Prenotazioni",
                    onClick: () => navigate(`/cassa/${ristoranteId}/prenotazioni`),
                    url: `/cassa/${ristoranteId}/prenotazioni`
                }
            ]
        }
    ];
}


export function createServiceItemList(ristoranteId: string, navigate: NavigateFunction) {

    if (UserAuthenticated.getInstance().abilitaModuloServizio === false) {
        return [];
    }

    return [
        {
            title: "Servizio",
            items: [
                {
                    icon: <Icon icon="hugeicons:waiter" width="24" height="24" />,
                    text: "Cameriere",
                    onClick: () => navigate(`/servizio/${ristoranteId}/cameriere`),
                    url: `/servizio/${ristoranteId}/cameriere`
                },
                {
                    icon: <RequestQuoteIcon />,
                    text: "Pagamenti",
                    onClick: () => navigate(`/servizio/${ristoranteId}/pagamenti`),
                    url: `/servizio/${ristoranteId}/pagamenti`
                },
                /*{
                    icon: <Icon icon={PiattiIcon} width={25} />,
                    text: "Cucina",
                    onClick: () => navigate(`/servizio/${ristoranteId}/cucina`),
                    url: `/servizio/${ristoranteId}/cucina`

                },
                {
                    icon: <RequestQuoteIcon />,
                    text: "Pass",
                    onClick: () => navigate(`/servizio/${ristoranteId}/pass`),
                    url: `/servizio/${ristoranteId}/pass`
                },*/

            ]
        }
    ];
}


export function createSettingsRestaurantItemList(ristoranteId: string, navigate: NavigateFunction) {
    return [
        {
            title: "Impostazioni",
            items: [
                {
                    icon: <Icon icon={"fluent:info-24-regular"} width={25} />,
                    text: "Informazioni",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/info`),
                    url: `/impostazioni/${ristoranteId}/info`
                },
                {
                    icon: <Icon icon={"fluent:payment-24-regular"} width={25} />,
                    text: "Pagamenti",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/payment`),
                    url: `/impostazioni/${ristoranteId}/payment`
                },
                {
                    icon: <Icon icon={"fluent:map-24-regular"} width={25} />,
                    text: "Mappa",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/map`),
                    url: `/impostazioni/${ristoranteId}/map`
                },
                {
                    icon: <Icon icon={"fluent:clock-24-regular"} width={25} />,
                    text: "Orari",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/timetables`),
                    url: `/impostazioni/${ristoranteId}/timetables`
                },
                {
                    icon: <Icon icon={"fluent:table-bottom-row-24-regular"} width={25} />,
                    text: "Tavoli",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/tables`),
                    url: `/impostazioni/${ristoranteId}/tables`
                },
                {
                    icon: <PrintIcon />,
                    text: "Gestione stampanti",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/managePrinters`),
                    url: `/impostazioni/${ristoranteId}/managePrinters`
                },
                {
                    icon: <Icon icon={"fluent:mail-24-regular"} width={25} />,
                    text: "Email reportistica",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/emailReporting`),
                    url: `/impostazioni/${ristoranteId}/emailReporting`
                }
            ]
        },
        {
            title: "Integrazioni",
            items: [
                {
                    icon: <img alt="deliverect-integration" src="/deliverect-logo.png" width={25} />,
                    text: "Deliverect",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/deliverectIntegrazione`),
                    url: `/impostazioni/${ristoranteId}/deliverectIntegrazione`
                },
                {
                    icon: <img alt="tilby-integration" src="/tilby-logo.webp" width={25} />,
                    text: "Tilby",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/tilbyIntegrazione`),
                    url: `/impostazioni/${ristoranteId}/tilbyIntegrazione`
                },
                {
                    icon: <img alt="cassaincloud-integration" src="/caCloudLog.webp" width={25} />,
                    text: "Cassa in Cloud",
                    onClick: () => navigate(`/impostazioni/${ristoranteId}/caIncloudIntegrazione`),
                    url: `/impostazioni/${ristoranteId}/caIncloudIntegrazione`
                }
            ]
        },
    ];
}

export function createChatItemList(ristoranteId: string, navigate: NavigateFunction) {
    if (UserAuthenticated.getInstance().abilitaModuloChat === false) {
        return [];
    }

    return [
        {
            title: "Chat",
            items: [
                {
                    icon: <Icon icon={"fluent:info-24-regular"} width={25} />,
                    text: "Chat",
                    onClick: () => navigate(`/chat/${ristoranteId}`),
                    url: `/chat/${ristoranteId}/info`
                }
            ]
        }
    ];
}